// Community work and events, one unified list rendered with a single card
// system (see Community.jsx). `image` and `socials` are optional — add
// them as they exist and they'll render as a photo + social icons.
// `period` is optional too — leave blank until confirmed, rather than
// guessing.
//
// `orientation` tells the card which way to lay itself out so the photo
// fills its slot without a bad crop: "landscape" -> full-width banner on
// top, "portrait" -> a side column. Set it to match the actual photo file
// (check with `sips -g pixelWidth -g pixelHeight <file>` if unsure).
//
// To add a photo: drop the file in `public/images/community/` and set
// `image` to its path, e.g. "/images/community/zk-chennai.jpeg".
export const community = [
  {
    org: "EigenLayer Restaking Day",
    role: "Organizing Team Member & Speaker",
    location: "Chennai",
    period: "", // TODO: add event date
    highlights: [
      "Organized and delivered sessions explaining decentralized infrastructure expansion models.",
      "Facilitated technical and strategic discussions within the developer ecosystem.",
    ],
    image: "/images/community/eigenlayer-restaking-day-chennai.jpg",
    orientation: "landscape",
    socials: {
      twitter: "https://x.com/Web3Chennai/status/1912456209162203158?s=20",
      linkedin:
        "https://www.linkedin.com/posts/madhu-varsha-p-a7ba26259_restaking-day-recap-i-gave-a-talk-at-restaking-activity-7317377830575558656-I-98",
    },
  },
  {
    org: "Build dApps on Lens Chain",
    role: "Host & Speaker",
    location: "",
    period: "", // TODO: add event date
    highlights: [
      "Hosted my first in-person developer event, guiding participants through building and deploying their own decentralized applications.",
      "Walked attendees through hands-on dApp development, from smart contract basics to a working front end.",
    ],
    image: "/images/community/build-dapps-event.jpg",
    orientation: "landscape",
    socials: {
      twitter: "https://x.com/madhuvarsha_/status/1937485506566324682?s=20",
      linkedin:
        "https://www.linkedin.com/posts/madhu-varsha-p-a7ba26259_first-time-hosted-an-irl-event-build-dapps-activity-7343334038704660480-JtmD",
    },
  },
  {
    org: "Zero Knowledge (ZK) Witness Series",
    role: "Organizer & Speaker",
    location: "Chennai",
    period: "",
    highlights: [
      "Part of a multi-city initiative introducing students and developers to Zero Knowledge cryptography and blockchain scalability, onboarding 50+ participants into emerging technology ecosystems.",
      "Organized and spoke at a developer-focused session on ZK cryptography and blockchain scalability, coordinating local community partnerships and event logistics.",
    ],
    image: "/images/community/zk-chennai.jpeg",
    orientation: "landscape",
    socials: {
      twitter: "https://x.com/ProofOfWitness/status/1936683769878253777?s=20",
      linkedin:
        "https://www.linkedin.com/posts/proofofwitness_yesterday-was-truly-special-we-hosted-the-ugcPost-7342453450321907712-cLXi",
    },
  },
  {
    org: "Zero Knowledge (ZK) Witness Series",
    role: "Organizer & Speaker",
    location: "Pondicherry",
    period: "",
    highlights: [
      "Part of a multi-city initiative introducing students and developers to Zero Knowledge cryptography and blockchain scalability, onboarding 50+ participants into emerging technology ecosystems.",
      "Organized and spoke at a developer-focused session on ZK cryptography and blockchain scalability, coordinating local community partnerships and event logistics.",
    ],
    image: "/images/community/zk-puducherry.jpg",
    orientation: "landscape",
    socials: {
      twitter: "https://x.com/ProofOfWitness/status/1947168754800201825?s=20",
      linkedin:
        "https://www.linkedin.com/posts/proofofwitness_zk-witness-pondicherry-edition-recap-this-ugcPost-7352937200981852161-8vPE",
    },
  },
  {
    org: "Zero Knowledge (ZK) Witness Series",
    role: "Organizer & Speaker",
    location: "Coimbatore",
    period: "",
    highlights: [
      "Part of a multi-city initiative introducing students and developers to Zero Knowledge cryptography and blockchain scalability, onboarding 50+ participants into emerging technology ecosystems.",
      "Organized and spoke at a developer-focused session on ZK cryptography and blockchain scalability, coordinating local community partnerships and event logistics.",
    ],
    image: "/images/community/zk-coimbatore.jpg",
    orientation: "landscape",
    socials: {
      twitter: "https://x.com/ProofOfWitness/status/1952300410397700359?s=20",
      linkedin:
        "https://www.linkedin.com/posts/proofofwitness_zk-witness-coimbatore-was-such-a-vibe-activity-7358154949203038209-gA8g",
    },
  },
  {
    // Ongoing role, not tied to one event — kept last since it's a group
    // photo rather than a specific post.
    org: "Web3Chennai",
    role: "Community Lead",
    location: "",
    period: "", // TODO: add start date
    highlights: [
      "Lead community-building initiatives focused on blockchain and emerging technologies.",
      "Organized educational workshops, speaker sessions, and developer meetups.",
      "Coordinated partnerships and fostered collaboration between students, developers, and ecosystem contributors.",
    ],
    image: "/images/community/web3chennai-community.jpg",
    orientation: "landscape",
    socials: { twitter: "", linkedin: "" },
  },
];
